import { Image, makeStyles, Tooltip } from "@fluentui/react-components";

interface IPlatform {
    key: string;
    name: string;
    height: number;
    width: number;
}

const platforms: IPlatform[] = [
    {
        key: "microsoft",
        name: "Microsoft",
        height: 76,
        width: 100
    },
    {
        key: "webcon",
        name: "Webcon BPS",
        height: 40,
        width: 50
    },
    {
        key: "dell",
        name: "Dell Technologies",
        height: 76,
        width: 100
    },
    {
        key: "cyberessentials",
        name: "Cyber Essentials",
        height: 76,
        width: 100
    }
];

const useStyles = makeStyles({
    contentContainer: {
        gridRow: '1 / -1',
        zIndex: 2,
        display: 'grid',
        placeItems: 'center',
        textAlign: 'center',
        padding: '2rem',
    },
    row: {
        display: "flex",
        justifyContent: "center",
        flexWrap: "wrap",
        gap: "2rem",
        marginBottom: "3rem",
        width: "100%"
    },
    title: {
        textTransform: "uppercase"
    },
    platform: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flex: "1 1 calc(16.66% - 2rem)",
        maxWidth: "calc(16.66% - 2rem)",

        "@media (max-width: 1200px)": {
            flex: "1 1 calc(33.33% - 2rem)",
            maxWidth: "calc(33.33% - 2rem)"
        },

        "@media (max-width: 768px)": {
            flex: "1 1 calc(50% - 2rem)",
            maxWidth: "calc(50% - 2rem)"
        },

        "& img": {
            width: "auto",
            maxWidth: "100%",
            maxHeight: "100px"
        }
    }
});

const Platform = (props: { platform: IPlatform }) => {
    const { platform } = props;
    const styles = useStyles();

    const imgPath = `img/helpdesk/platform-logos/${platform.key}.png`;

    return (
        <div className={styles.platform}>
            <Tooltip content={platform.name} relationship="label">
                <Image src={imgPath} alt={platform.name} width={platform.width} height={platform.height} />
            </Tooltip>
        </div>
    );
};

export default function Platforms() {
    const styles = useStyles();

    return (
        <div className={styles.contentContainer}>

            <div className={styles.row}>
                {platforms.map((platform) => <Platform key={platform.key} platform={platform} />)}
            </div>
        </div>
    );
}